module.exports = "\n<drop-file [ngClass]=\"dropFileContainerClass\" [disable]=\"disabled\" (files)=\"dropFilesHandler($event)\" [limit]=\"limit\"></drop-file>\n<app-gallery-modal [ngClass]=\"filesContainerClass\"\n(deleted)=\"deleteImage($event)\"\n></app-gallery-modal>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/drop-pics-gallery/drop-pics-gallery.component.html
// module id = ../../../../../src/app/shared/drop-pics-gallery/drop-pics-gallery.component.html
// module chunks = main